module.exports = __webpack_public_path__ + "static/media/mobileProgramsTile.533f59db.svg";